import { render } from "./ChatWhatsApp.vue?vue&type=template&id=c7320220&scoped=true&ts=true"
import script from "./ChatWhatsApp.vue?vue&type=script&lang=ts"
export * from "./ChatWhatsApp.vue?vue&type=script&lang=ts"

import "./ChatWhatsApp.vue?vue&type=style&index=0&id=c7320220&scoped=true&lang=less"

import exportComponent from "D:\\客户端h5\\operationmanual\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c7320220"]])

export default __exports__